import React, { useState, useEffect } from 'react';
import { Timer } from '../Header/HeaderStyles';

const EXPIRE_MINUTES = 29;
const SECONDS = 60;

let timerID: any;

interface Props {
    startTime?: Date,
    onExpireCallback?: () => void,
    isMobile?: boolean,
}

const CountdownTimer: React.FunctionComponent<Props> = props => {
    const [minutes, setMinutes] = useState('00');
    const [seconds, setSeconds] = useState('00');
    const onTick = () => {
        if(props.startTime) {
            const dateMs = new Date().getTime();
            const diffMS = Math.abs(props.startTime.getTime() - dateMs);
            const diffMinutes = EXPIRE_MINUTES - Math.floor(diffMS / 60000);
            const diffSeconds =  Math.floor(SECONDS - ((diffMS % 60000) / 1000));
            if(diffMinutes >= 0 && diffSeconds >= 0) {
                const strMinutes = diffMinutes < 10 ? `0${diffMinutes}` : diffMinutes.toFixed(0);
                const strSeconds = diffSeconds >= SECONDS ? '00' : diffSeconds <= 9 ? `0${diffSeconds.toFixed(0)}` : diffSeconds.toFixed(0);
                setMinutes(strMinutes);
                setSeconds(strSeconds);
            } else {
                if(props.onExpireCallback) {
                    props.onExpireCallback();
                }
            }
        }
    }
    useEffect(() => {
        timerID = setInterval(() => onTick(), 1000);
        return () => clearInterval(timerID);
    }, []);
    return (<Timer isMobile={props.isMobile}>
            {`${minutes || '00'}:${seconds || '00'}`}
        </Timer>
    );
};

export default CountdownTimer;
